import styled from 'styled-components'

interface ProgressBarItemProps {
  $progress: number
  height?: string
  $customColor?: string | null
}

export const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-grow: 1;
`

export const ProgressBarBg = styled.div<{ height?: string }>`
  width: 100%;
  background-color: #808191;
  border-radius: 9999px;
  ${({ height }) => `height: ${height || '5px'};`}
`

export const ProgressBarItem = styled.div<ProgressBarItemProps>`
  border-radius: 9999px;
  ${({ $customColor }) => `background-color: ${$customColor || '#F30C6D'};`}
  ${({ $progress }) => `width: ${Math.min(Math.max($progress, 0), 100)}%;`}
  ${({ height }) => `height: ${height || '5px'};`}
`

export const ProgressPercentage = styled.span`
  font-size: 0.75rem;
  color: white;
  font-weight: 600;
`
